import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { I18nService } from '@telecom/shared/services/i18n';
import { i18n } from '@/infrastructure/locales';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import { PsHttp$, PsHttpChannel, PsHttpChannelImpl } from '@patsnap/tahiti-core/common/http-channel';
import { Message } from '@patsnap/tahiti-core/common/message';
import { OpenService, OpenServiceImpl } from '@patsnap/tahiti-core/services/open-service';
import { Toast } from 'patsnap-biz';
import '@patsnap-biz/toast/lib/style';
import { InstallPages } from '@/services/install-pages/install-pages';
import { InstallPagesImpl } from '@/services/install-pages/impls/install-pages';
import { RouterProxy } from '@/services/router-proxy/router-proxy';
import { RouterProxyImpl } from '@/services/router-proxy/impls/router-proxy';
import { bindContributionProvider, CommandContribution, CommandRegistry, CommandService, LocationService, Logger } from '@patsnap/tahiti-core';
import { RouterService } from '@telecom/shared/services/router';
import { router } from '@/presentation/routers';
import { SSEPsHttpImpl } from '@/services/sse-ps-http/impls/sse-ps-http';
import { FactoryPsHttpSSE, PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import { SSEPsHttpImpl as SSEPsHttpImplOfficial, FactoryPsHttpSSE as FactoryPsHttpSSEOfficial, PsHttpSSE as PsHttpSSEOfficial } from '@patsnap-utils/sse';
import { ConfirmService, RequestConfirmDialog } from '@/services/confirm-service/confirm-service';
import { createRequestConfirmDialog, VueConfirmService } from '@/services/confirm-service/impls/confirm-service';
import { ReferenceAnchor, ReferenceAnchorIndexGenerator } from '@telecom/shared/services/reference-anchor/reference-anchor';
import { ReferenceAnchorImpl } from '@telecom/shared/services/reference-anchor/impls/reference-anchor';
import { ReferenceAnchorIndexGeneratorImpl } from '@telecom/shared/services/reference-anchor/impls/reference-anchor-index-generator';
import { UnauthenticatedHandlerImpl } from '@telecom/shared/services/unauthenticated-handler/impls/unauthenticated-handler';
import { UnauthenticatedHandler } from '@telecom/shared/services/unauthenticated-handler/unauthenticated-handler';
import { UnauthorizedHandlerImpl } from '@/services/unauthorized-handler/impls/unauthorized-handler';
import { UnauthorizedHandler } from '@/services/unauthorized-handler/unauthorized-handler';
import { PageInitServiceImpl } from '@/services/page-init-service/impls/page-init-service';
import { PageInitService } from '@/services/page-init-service/page-init-service';
import { AiAgentEnvService } from '@telecom/shared/services/ai-agent-env-service/ai-agent-env-service';
import { AiAgentEnvServiceImpl } from '@telecom/shared/services/ai-agent-env-service/impls/ai-agent-env-service';
import { UsageLimitHandlerImpl } from '@/services/usage-limit-handler/impls/usage-limit-handler';
import { UsageLimitHandler } from '@/services/usage-limit-handler/usage-limit-handler';
import { CreditsChargeService } from '@/services/credits-charge-service/credits-charge-service';
import { CreditsChargeServiceImpl } from '@/services/credits-charge-service/impls/credits-charge-service';
import { NewUserInitializationService } from '@/services/new-user-initialization-service/new-user-initialization-service';
import { NewUserInitializationServiceImpl } from '@/services/new-user-initialization-service/impls/new-user-initialization-service';

export const baseModule = new ContainerModule((bind) => {
    bind(I18nService).toConstantValue(i18n.global);
    bind(Logger).toConstantValue({
        log: (message: string, ...rest: any[]) => console.log(`[${new Date().toLocaleString()}] %c${message}`, ...rest),
        info: (message: string, ...rest: any[]) => console.info(`[${new Date().toLocaleString()}] %c${message}`, 'color: white;background-color: #1976D2;padding: 2px 4px;border-radius: 4px;', ...rest),
        error: (message: string, ...rest: any[]) => console.error(`%c[${new Date().toLocaleString()}] ${message}`, 'color: white;background-color: #dc7c08;padding: 2px 4px;border-radius: 4px;', ...rest),
        warn: (message: string, ...rest: any[]) => console.warn(`[${new Date().toLocaleString()}] %c${message}`, ...rest),
    });
    bind(PsHttp).toConstantValue(psHttp);
    bind(PsHttp$).toConstantValue(psHttp$);
    bind(PsHttpChannel).to(PsHttpChannelImpl);
    bind(Message).toConstantValue(Toast);
    bind(OpenService).to(OpenServiceImpl);
    bind(InstallPages).to(InstallPagesImpl);
    bind(RouterProxy).to(RouterProxyImpl);
    bind(CommandRegistry).toSelf();
    bind(CommandService).toDynamicValue(context => context.container.get(CommandRegistry));
    bindContributionProvider(bind, CommandContribution);
    bind(RouterService).toConstantValue(router);
    bind(PsHttpSSE).to(SSEPsHttpImpl).inRequestScope();
    bind(FactoryPsHttpSSE).toDynamicValue(context => () => context.container.get(PsHttpSSE));
    bind(PsHttpSSEOfficial).to(SSEPsHttpImplOfficial).inRequestScope();
    bind(FactoryPsHttpSSEOfficial).toDynamicValue(context => () => context.container.get(PsHttpSSEOfficial));
    bind(ConfirmService).to(VueConfirmService);
    bind(RequestConfirmDialog).toDynamicValue(createRequestConfirmDialog());
    bind(ReferenceAnchor).to(ReferenceAnchorImpl);
    bind(ReferenceAnchorIndexGenerator).to(ReferenceAnchorIndexGeneratorImpl);
    bind(UnauthorizedHandler).to(UnauthorizedHandlerImpl);
    bind(UnauthenticatedHandler).to(UnauthenticatedHandlerImpl);
    bind(UsageLimitHandler).to(UsageLimitHandlerImpl);
    bind(LocationService).toConstantValue(window.location);
    bind(PageInitService).to(PageInitServiceImpl);
    bind(CreditsChargeService).to(CreditsChargeServiceImpl).inSingletonScope();
    bind(NewUserInitializationService).to(NewUserInitializationServiceImpl).inSingletonScope();
    bind(AiAgentEnvService).to(AiAgentEnvServiceImpl);
});
